import Heading from '@react/react-spectrum/Heading'
import Button from '@react/react-spectrum/Button'
import { useRootContext } from '../../root/RootContext'

export default function TopRibbon() {
  const { project } = useRootContext()
  return (
    <div class='warning' style={{
        textAlign: "center"
      }}>
      <Heading size={5} className='heading' style={{
          display: "inline-block",
          margin: "1rem"
        }}>
        Selected project is not connected to any AEP environment.
        <br />
      </Heading>
      <Button
        style={{
          top: "10%",
          margin: "0.5rem"
        }}
        variant='cta'
        onClick={() => {
          window.location = `/projects/${project.meta.id}/integrations`
        }}
      >
        Configure
      </Button>
    </div>
  )
}
